import type { SignupMutation, SignupParams } from '@/generated/hasura';
import { signup } from '@/graphql/hasura/auth/signup';
import { initializeApollo } from '@/lib/apollo/apollo-client';
import { AlterError } from '@/lib/error';

const context = { clientName: 'rapptr' };

export type SignupParamsTokenSet = NonNullable<NonNullable<SignupMutation['signup']>['tokenSet']>;

export const signupUser = async (signupParams: SignupParams): Promise<SignupParamsTokenSet> => {
  const apolloClient = initializeApollo();
  const { data } = await apolloClient.mutate<SignupMutation>({
    mutation: signup,
    context,
    variables: {
      signupParams,
    },
  });
  if (data?.signup?.alterError) {
    throw new AlterError(data.signup.alterError);
  }
  const tokenSet = data?.signup?.tokenSet;
  if (!tokenSet) {
    throw new Error('TOKEN_SET_NOT_DEFINED');
  }
  return tokenSet;
};
